webpackJsonp([241083017184588],{

/***/ 330:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"leadBackgroundImage":"src-templates----blog-post-module---leadBackgroundImage---RxIr2","storyHeadline":"src-templates----blog-post-module---storyHeadline---1319e","introContainer":"src-templates----blog-post-module---introContainer---Fb3_9","storyContent":"src-templates----blog-post-module---storyContent---2hsVT"};

/***/ }),

/***/ 230:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(194);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _get = __webpack_require__(73);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _Head = __webpack_require__(42);
	
	var _Head2 = _interopRequireDefault(_Head);
	
	var _blogPostModule = __webpack_require__(330);
	
	var _blogPostModule2 = _interopRequireDefault(_blogPostModule);
	
	var _defaultModule = __webpack_require__(25);
	
	var _defaultModule2 = _interopRequireDefault(_defaultModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* old img query : ?w=1180&h=400&fit=fill */
	var BlogPostTemplate = function (_React$Component) {
	  _inherits(BlogPostTemplate, _React$Component);
	
	  function BlogPostTemplate() {
	    _classCallCheck(this, BlogPostTemplate);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  BlogPostTemplate.prototype.render = function render() {
	    var post = (0, _get2.default)(this.props, 'data.contentfulBlogPost');
	    var siteTitle = (0, _get2.default)(this.props, 'data.site.siteMetadata.title') || "Gila PHX";
	    var description = decodeURIComponent(post.description.childMarkdownRemark.html.replace(/<[^>]+>/g, ''));
	
	    var photographer = post.photographer ? _react2.default.createElement(
	      'p',
	      null,
	      'Photography by ',
	      _react2.default.createElement(
	        'span',
	        null,
	        post.photographer
	      )
	    ) : null;
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_Head2.default, { title: post.title, author: post.authors, description: description, keywords: post.tags }),
	      _react2.default.createElement(
	        'div',
	        { className: _defaultModule2.default.fullPageWrapper },
	        _react2.default.createElement(
	          'div',
	          { className: _blogPostModule2.default.leadBackgroundImage, style: { backgroundImage: 'url(' + post.leadImage.file.url + ')' } },
	          _react2.default.createElement(
	            'h1',
	            { className: _blogPostModule2.default.storyHeadline },
	            post.title
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _blogPostModule2.default.introContainer },
	          _react2.default.createElement(
	            'h2',
	            null,
	            post.subtitle
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              'Published on ',
	              _react2.default.createElement(
	                'date',
	                null,
	                post.publishDate
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Written by ',
	              _react2.default.createElement(
	                'author',
	                null,
	                post.authors
	              )
	            ),
	            photographer
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _defaultModule2.default.sectionWrapper },
	          _react2.default.createElement('div', {
	            className: _blogPostModule2.default.storyContent,
	            dangerouslySetInnerHTML: {
	              __html: post.body.childMarkdownRemark.html
	            }
	          }),
	          _react2.default.createElement(
	            'span',
	            { className: _defaultModule2.default.invertText },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: '/stories' },
	              'More Stories'
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return BlogPostTemplate;
	}(_react2.default.Component);
	
	exports.default = BlogPostTemplate;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-story-post-js-9a50df6af87c369a8048.js